import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '../../../store';
import { ConstantsService } from '../../../core/services/constants.service';
import { InstrumentItem } from '../../../core/models/InstrumentItem';
import { TradeSimulation } from '../../../core/models/TradeSimulation';
import { NotificationPopupComponent } from '../notification-popup/notification-popup.component';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { UtilityService } from '../../../core/services/utility.service';
import { Router } from '@angular/router';
import { DataService } from '../../../core/services/data.service';
import * as _ from 'underscore';
import moment from 'moment';
import { isNil } from 'lodash-es';
import { isUndefined } from 'lodash-es';
import { LegalEntity } from '../../../core/models/LegalEntity';
import { CounterpartyTradeValue } from '../../../core/models/CounterPartyTradeValue';
import { NotifPollingService } from '../../../core/services/notif-polling.service';
import { CustomValidatorsService } from '../../../core/services/custom-validators.service';
import { InstrumentItemImpl } from './instrumentItemImpl';




@Component({
    selector: 'app-new-derivative-collateral-modal',
    templateUrl: './new-derivative-collateral-modal.component.html',
    styleUrls: ['./new-derivative-collateral-modal.component.scss'],
    standalone: false
})
export class NewDerivativeCollateralModalComponent implements OnInit {
    public setupIsDone = false;
    private _tradeSimulation;
    @Input()
    set tradeSimulation(value: TradeSimulation) {
        this._tradeSimulation = value;
        if (!isNil(value) && !this.setupIsDone) {
            this.setupIsDone = true;
            this.setup();
        }
    }
    get tradeSimulation(): TradeSimulation {
        return this._tradeSimulation;
    }

    @Input()
    mode: string;

    @Input()
    legalEntityName: string;

    modelPopupMode: any;
    form: UntypedFormGroup;
    dataLoading: boolean;
    legalEntity: LegalEntity;
    accountingValueTotal = 0;

    get instruments() {
        return this.form.get('instruments') as UntypedFormArray;
    }

    get counterpartyTradeValues() {
        return this.form.get('counterpartyTradeValues') as UntypedFormArray;
    }

    constructor(public activeModal: NgbActiveModal, private store: Store, private constantsService: ConstantsService,
        private modalService: NgbModal, private fb: UntypedFormBuilder, private utility: UtilityService, private router: Router,
        private dataService: DataService, private pollingService: NotifPollingService,
        private customValidatorsService: CustomValidatorsService) {
        this.modelPopupMode = this.constantsService.modelPopupMode;
        this.initialiseNewSimulation();
    }

    ngOnInit() {
        if (this.tradeSimulation) {
            this.setupIsDone = true;
            this.setup();
        }
    }

    setup() {
        this.legalEntity = _.find(this.store.value.user.legalEntities, (x: any) => x.dataName === this.legalEntityName);
        switch (this.mode) {
            case this.modelPopupMode.tradeExecuted: {
                this.getTradeInstruments(this.tradeSimulation.modelId);
                break;
            }
            case this.modelPopupMode.edit: {
                this.getTradeInstruments(this.tradeSimulation.modelId);
                break;
            }
            case this.modelPopupMode.view: {
                this.getTradeInstruments(this.tradeSimulation.modelId);
                if (this.form.controls['modelName']) {
                    this.form.controls['modelName'].disable();
                }
                break;
            }
            default: {
                this.tradeSimulation = <TradeSimulation>{};
                this.tradeSimulation.instruments = [<InstrumentItem>{}];
                this.tradeSimulation.modelName = '';
                break;
            }
        }
    }
    initialiseNewSimulation() {
        this.form = this.fb.group({
            modelName: ['', Validators.required],
            instruments: this.fb.array([this.createNewInstrumentFormControl(null)]),
            status: [this.constantsService.modelStatus.pending],
            tradeExecuted: [false],
            userName: this.getUserName()
        }, {
            validator: this.customValidatorsService.atLeastOneInstrument
        });
    }

    getTradeInstruments(modelId: string) {
        this.dataLoading = true;
        this.dataService.getTradeInformation(modelId).subscribe(result => {
            this.dataLoading = false;
            if (result.tradeInstruments && result.tradeInstruments.length > 0) {
                const instruments: InstrumentItem[] = this.utility.simuRxCallback(result.tradeInstruments);
                this.processInstrumentsIntoTradeObject(instruments);
            }
        }, error => {
            alert('Error happened while getting trade data.');
        });
    }

    processInstrumentsIntoTradeObject(instruments: any[]) {
        this.tradeSimulation.instruments = _.map(instruments, x => this.mapApiToUiInstrument(x));
        this.tradeSimulation.counterpartyTradeValues = this.getCounterPartyTradeValues(this.tradeSimulation.instruments);
        this.tradeSimulation.tradeExecuted = this.tradeSimulation.instruments[0].tradeExecuted;
        this.tradeSimulation.rowKeys = _.map(this.tradeSimulation.instruments, (x: InstrumentItem) => x.rowKey);
        const processInstruments = this.getTradeExecutedInstruments(this.tradeSimulation.instruments).sort((a, b) => this.utility.compareInstruments(a, b));

        this.form = this.fb.group({
            modelName: [this.tradeSimulation.modelName, Validators.required],
            instruments: this.fb.array(_.map(processInstruments, x => {
                const y = { ['leg1IrsNotional']: '', ['leg2IrsNotional']: '', ...x };
                return this.fb.group(y)
            })),
            counterpartyTradeValues: this.fb.array(_.map(this.tradeSimulation.counterpartyTradeValues, x => this.fb.group(x))),
            status: [this.tradeSimulation.status],
            tradeExecuted: [this.modelPopupMode.tradeExecuted ? true : this.tradeSimulation.tradeExecuted],
            modelId: [this.tradeSimulation.modelId],
            userName: [this.tradeSimulation.userName],
            createdDate: [this.tradeSimulation.createdDate],
            lastUpdated: [this.tradeSimulation.lastUpdated],
            rowKeys: [this.tradeSimulation.rowKeys]
        });
        if (this.mode === this.modelPopupMode.view) {
            if (!isNil(this.form.controls['modelName'])) {
                this.form.controls['modelName'].disable();
            }
            if (!isNil(this.form.controls['accountingValue'])) {
                this.form.controls['accountingValue'].disable();
            }
        }
    }

    getCounterPartyTradeValues(instruments: InstrumentItem[]): CounterpartyTradeValue[] {
        if (!instruments || instruments.length === 0) {
            return null;
        }

        if (instruments[0].counterParty == null || instruments[0].counterParty === '') {
            return _.map(this.legalEntity.counterParties, x => this.createCounterpartyTradeValueObject(x, 0));
        }

        const groupByCounterParty = _.groupBy(instruments, 'counterParty');
        return _.map(Object.keys(groupByCounterParty),
            x => this.createCounterpartyTradeValueObject(x, groupByCounterParty[x][0].accountingValue));
    }

    createCounterpartyTradeValueObject(counterParty: string, value: number): CounterpartyTradeValue {
        return <CounterpartyTradeValue>{
            counterParty: counterParty,
            accountingValue: value
        };
    }

    mapApiToUiInstrument(instrument: any): InstrumentItem {
        const obj = <InstrumentItem>instrument;

        for (const field in instrument) {
            if (obj.hasOwnProperty(field) && field.endsWith('Date')) {
                if (instrument[field] && this.utility.isValidDateByDateFormat(instrument[field],
                    this.constantsService.dateFormats.YYYYMMDD_HHmmss)) {
                    obj[field] = moment(instrument[field], this.constantsService.dateFormats.YYYYMMDD_HHmmss, true)
                        .format(this.constantsService.dateFormats.DMYYYY);
                }
            }
        }
        return obj;
    }

    getExecutedTradeInstruments(instruments: InstrumentItem[]): InstrumentItem[] {
        if (instruments.length === 0 || !instruments[0].tradeExecuted) {
            return instruments;
        }

    }

    createNewInstrumentFormControl(instrumentName: string) {
        const fbGrpObj = {
            instrType: instrumentName,
            entity: [this.legalEntityName],
            leg2Fund: [this.legalEntityName],
            userName: this.getUserName(),
            status: [''],
        };
        const instr = new InstrumentItemImpl();
        for (const k in instr) {
            if (instr.hasOwnProperty(k)) {
                if (fbGrpObj[k] === undefined) {
                    fbGrpObj[k] = '';
                }
            }
        }
        return this.fb.group(fbGrpObj);
    }

    onRemoveInstrument(index: number) {
        if (this.mode === this.modelPopupMode.tradeExecuted || this.mode === this.modelPopupMode.edit) {
            const modalRef = this.modalService.open(NotificationPopupComponent,
                { centered: true, windowClass: 'notification-modal', backdrop: 'static' });
            modalRef.result.then((result) => {
                if (result === 'ok') {
                    this.instruments.removeAt(index);
                }
            }).catch(() => {
            });
            modalRef.componentInstance.notificationPopupMode = this.constantsService.notificationPopupMode.deleteInstrument;
            return;
        }
        this.instruments.removeAt(index);
    }

    addNewInstrument() {
        this.instruments.push(this.createNewInstrumentFormControl(null));
    }

    deleteModel() {
        if (this.mode === this.modelPopupMode.tradeExecuted || this.mode === this.modelPopupMode.edit) {
            const modalRef = this.modalService.open(NotificationPopupComponent,
                { centered: true, windowClass: 'notification-modal' });
            modalRef.result.then((result) => {
                console.log('deleteModel:', result);
            }).catch((err) => {
                console.log('deleteModelError:', err);
            });
            modalRef.componentInstance.notificationPopupMode = this.constantsService.notificationPopupMode.deleteModel;
        }
    }

    tradeExecuted() {
        if (!this.tradeSimulation.tradeExecuted && this.mode !== this.modelPopupMode.tradeExecuted) {
            this.mode = this.modelPopupMode.tradeExecuted;
            return;
        }

        if (this.form.valid) {
            const tempModelName = this.form.controls.modelName.value.replace(/[^a-zA-Z0-9àâçéèêëîïôûùüÿñæœ\s\-_]/g, '')
            this.form.controls.modelName.setValue(tempModelName)
            this.activeModal.close(this.prepareSimulationToSave(this.form.value));
            return;
        }
    }

    prepareSimulationToSave(tradeSimulation: TradeSimulation): TradeSimulation {
        _.each(tradeSimulation.instruments.filter((item: InstrumentItem) => !!item.instrType), (item: InstrumentItem) => {

            for (const key of Object.keys(item)) {
                if (key.startsWith('leg1') && key.endsWith('Date')) {
                    if (key.includes('Maturity')) {
                        this.prepareDate(item, key, '2100-01-01');
                    }
                    else if (key.includes('Issue')) {
                        this.prepareDate(item, key, null);
                    }
                }
            }
            item.modelName = this.utility.trimString(item.modelName);
            item.userName = this.utility.trimString(tradeSimulation.userName);
            item.createdDate = moment().format(this.constantsService.dateFormats.YYYYMMDD_HHmmss);
            item.lastUpdated = moment().format(this.constantsService.dateFormats.YYYYMMDD_HHmmss);
            item.leg1Id = this.utility.trimString(item.leg1Id);
            item.instrType = this.utility.trimString(item.instrType);
            if (item.instrType === 'IRS') {
                if (isUndefined(item.leg1LegType) && !isUndefined(item.leg2LegType)) {
                    item.leg1LegType = (item.leg2LegType === '1') ? '0' : '1';
                }
                else if (isUndefined(item.leg2LegType) && !isUndefined(item.leg1LegType)) {
                    item.leg2LegType = (item.leg1LegType === '1') ? '0' : '1';
                }
            }
            item.leg1LegType = item.leg1LegType ? item.leg1LegType : '0';
            item.leg2LegType = item.leg2LegType ? item.leg2LegType : '0';
            item.leg1Currency = this.utility.trimString(item.leg1Currency);
            item.leg1Currency = this.utility.trimString(item.leg1Currency);
            item.leg2Currency = this.utility.trimString(item.leg2Currency);
            item.leg1BondCurrency = this.utility.trimString(item.leg1BondCurrency);
            item.leg2BondCurrency = this.utility.trimString(item.leg2BondCurrency);
            item.leg1AgainstCurrency = this.utility.trimString(item.leg1AgainstCurrency);
            item.leg2AgainstCurrency = this.utility.trimString(item.leg2AgainstCurrency);
            item.leg1RefForward = this.utility.trimString(item.leg1RefForward);
            item.leg2RefForward = this.utility.trimString(item.leg2RefForward);
            item.entity = this.legalEntityName;
            item.modelName = tradeSimulation.modelName;

            item.currency = item.leg1Currency;
            item.bondCurrency = this.utility.trimString(item.leg1BondCurrency);
            item.againstCurrency = this.utility.trimString(item.leg1AgainstCurrency);
            item.positionDate = moment('2000-01-01').format(this.constantsService.dateFormats.YYYYMMDD_HHmmss);

            item.bondNotional = this.getZeroIfUndefined(item.bondNotional);
            item.fxRate = this.getZeroIfUndefined(item.fxRate);
            item.repoRate = this.getZeroIfUndefined(item.repoRate);

            item.leg1Notional = this.getEmptyStringIfUndefined(item.leg1Notional);
            item.leg1IrsNotional = this.getEmptyStringIfUndefined(item.leg1IrsNotional);
            item.leg1FixedRateCoupon = this.getZeroIfUndefined(item.leg1FixedRateCoupon);
            item.leg1PnlAccounting = this.getZeroIfUndefined(item.leg1PnlAccounting);
            item.leg1HaircutAfterPricing = item.leg1HaircutAfterPricing ? item.leg1HaircutAfterPricing : 1;
            item.leg1PriceAccounting = this.getEmptyStringIfUndefined(item.leg1PriceAccounting);
            item.leg1CouponFrequency = this.getZeroIfUndefined(item.leg1CouponFrequency);
            item.leg1Spread = this.getZeroIfUndefined(item.leg1Spread);
            item.leg1Amount = this.getZeroIfUndefined(item.leg1Amount);
            item.leg1NpvUsd = this.getZeroIfUndefined(item.leg1NpvUsd);
            item.leg1DisCurve = this.getEmptyStringIfUndefined(item.leg1DisCurve);
            item.leg1PrincipalExchanged = this.getEmptyStringIfUndefined(item.leg1PrincipalExchanged);
            item.leg1FloatingRate = this.getZeroIfUndefined(item.leg1FloatingRate);
            item.leg1BasicCurve = this.getZeroIfUndefined(item.leg1BasicCurve);
            item.leg1PayBackNotional = this.getZeroIfUndefined(item.leg1PayBackNotional);
            item.leg1ZSpread = this.getZeroIfUndefined(item.leg1ZSpread);
            item.leg1PayNotional = this.getZeroIfUndefined(item.leg1PayNotional);
            item.leg1BondNotional = this.getZeroIfUndefined(item.leg1BondNotional);
            item.leg1FxRate = this.getZeroIfUndefined(item.leg1FxRate);
            item.leg1RepoRate = this.getZeroIfUndefined(item.leg1RepoRate);

            item.leg2Notional = this.getEmptyStringIfUndefined(item.leg2Notional);
            item.leg2IrsNotional = this.getEmptyStringIfUndefined(item.leg2IrsNotional);
            item.leg2FixedRateCoupon = this.getZeroIfUndefined(item.leg2FixedRateCoupon);
            item.leg2PnlAccounting = this.getZeroIfUndefined(item.leg2PnlAccounting);
            item.leg2HaircutAfterPricing = item.leg2HaircutAfterPricing ? item.leg2HaircutAfterPricing : 1;
            item.leg2PriceAccounting = this.getEmptyStringIfUndefined(item.leg2PriceAccounting);
            item.leg2CouponFrequency = this.getZeroIfUndefined(item.leg2CouponFrequency);
            item.leg2Spread = this.getZeroIfUndefined(item.leg2Spread);
            item.leg2Amount = this.getZeroIfUndefined(item.leg2Amount);
            item.leg2NpvUsd = this.getZeroIfUndefined(item.leg2NpvUsd);
            item.leg2DisCurve = this.getEmptyStringIfUndefined(item.leg2DisCurve);
            item.leg2PrincipalExchanged = this.getEmptyStringIfUndefined(item.leg2PrincipalExchanged);
            item.leg2FloatingRate = this.getZeroIfUndefined(item.leg2FloatingRate);
            item.leg2BasicCurve = this.getZeroIfUndefined(item.leg2BasicCurve);
            item.leg2PayBackNotional = this.getZeroIfUndefined(item.leg2PayBackNotional);
            item.leg2ZSpread = this.getZeroIfUndefined(item.leg2ZSpread);
            item.leg2PayNotional = this.getZeroIfUndefined(item.leg2PayNotional);
            item.leg2BondNotional = this.getZeroIfUndefined(item.leg2BondNotional);
            item.leg2FxRate = this.getZeroIfUndefined(item.leg2FxRate);
            item.leg2RepoRate = this.getZeroIfUndefined(item.leg2RepoRate);
            item.accountingValue = this.getZeroIfUndefined(item.accountingValue);

            item.tradeExecuted = this.mode === this.modelPopupMode.tradeExecuted || item.tradeExecuted === true;

            const instrumentConfig = _.find(this.constantsService.instrumentConfigs, (x: any) => x.instrument === item.instrType);
            if (instrumentConfig && instrumentConfig.defaultSetter && _.isFunction(instrumentConfig.defaultSetter)) {
                instrumentConfig.defaultSetter(item);
            }
        });
        return tradeSimulation;
    }

    getEmptyStringIfUndefined(value) {
        return value === undefined || value === null ? '' : value;
    }

    getZeroIfUndefined(value) {
        return value === undefined || value === null ? 0 : value;
    }

    saveModel() {
        if (this.form.valid) {
            const tempModelName = this.form.controls.modelName.value
            if (!(/[^a-zA-Z0-9àâçéèêëîïôûùüÿñæœ\s\-_.()]/g.test(tempModelName))) {
                const modalRef = this.modalService.open(NotificationPopupComponent,
                { centered: true, windowClass: 'notification-modal', backdrop: 'static' });
                modalRef.result.then((result) => {
                    if (result === 'ok') {
                        this.activeModal.close(this.prepareSimulationToSave(this.form.value));
                        this.pollingService.restartNotificationPolling();
                        return;
                    }
                }).catch(() => {
                });
                modalRef.componentInstance.notificationPopupMode = this.constantsService.notificationPopupMode.modelSimulationRequest;
            } else {
                alert("Enter a valid Model Name !")
            }
        }
    }

    changeToTradeExecuted() {

    }

    public getUserName(): string {
        return this.store.value.user && this.store.value.user.uid
            ? this.store.value.user.uid : '';
    }

    private getTradeExecutedInstruments(instruments: InstrumentItem[]): InstrumentItem[] {
        if (!instruments || instruments.length === 0) {
            return instruments;
        }

        const groupByCounterParty = _.groupBy(instruments, 'counterParty');

        if (Object.keys(groupByCounterParty).length > 0) {
            return groupByCounterParty[Object.keys(groupByCounterParty)[0]];
        }

        return instruments;
    }

    prepareDate(item: any, leg1field: string, defaultDate: string) {
        const leg2field = 'leg2' + leg1field.substring(4);
        item[leg1field] = this.getEmptyStringIfUndefined(item[leg1field]);
        if (item[leg1field]) {
            item[leg1field] = moment(item[leg1field], this.constantsService.dateFormats.DMYYYY, true)
                .format(this.constantsService.dateFormats.YYYYMMDD_HHmmss);
        } else if (defaultDate) {
            item[leg1field] = moment(defaultDate).format(this.constantsService.dateFormats.YYYYMMDD_HHmmss)
        } else {
            item[leg1field] = '';
        }

        item[leg2field] = this.getEmptyStringIfUndefined(item[leg2field]);

        if (item[leg2field]) {
            item[leg2field] = moment(item[leg2field], this.constantsService.dateFormats.DMYYYY, true)
                .format(this.constantsService.dateFormats.YYYYMMDD_HHmmss);
        } else {
            item[leg2field] = item[leg1field];
        }
    }

}
